
    <ngx-ui-loader fgsColor="blue" pbColor="blue" text="please wait"></ngx-ui-loader>
    <router-outlet></router-outlet>

   
